import {css, cx} from "emotion";
import * as React from "react";

import "./div-collapser-1.scss";

import {cs}           from "@Common/react/chain-services";
import {DivCollapser} from "@Common/ui-components/heavy/common/design2/div-collapser/div-collapser";

export const DivCollapser1 = ({className, expandedBottomPadding, collapsedHeight, renderContent}) => cs(
    ["divCollapser", (_, next) => DivCollapser({
        expandedBottomPadding,
        collapsedHeight,
        next,
    })],
    ({divCollapser}) => (
        <div
            className={cx(
                "div-collapser-1-1jj",
                className,
                divCollapser.state,
                css`
                  &.expanded {
                    padding-bottom: ${expandedBottomPadding}px;
                  }
                `
            )}
            ref={divCollapser.outerRef}
            style={{
                ...!divCollapser.expanded && {
                    maxHeight: divCollapser.outerHeight,
                }
            }}
        >
            {renderContent(divCollapser.innerRef)}

            {!divCollapser.pointless && (
                <div
                    className="toggle"
                    onClick={divCollapser.toggle}
                    xd-qa-type="link"
                    xd-qa-name={(divCollapser.collapsed || divCollapser.collapsing) ? (
                        "More"
                    ) : (
                        "Less"
                    )}
                >
                    {(divCollapser.collapsed || divCollapser.collapsing) ? (
                        "+ More"
                    ) : (
                        "- Less"
                    )}
                </div>
            )}
        </div>
    ),
);
